'use strict';
vendorListingController.$inject = ['$scope', '$rootScope', '$interval', 'dialogHelper', 'reportHelper', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('vendorListingController', vendorListingController);

function vendorListingController($scope, $rootScope, $interval, dialogHelper, reportHelper, BUSY_MESSAGE) {
	var viewModel = getViewModel($rootScope.mode || 'fund');
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			message: BUSY_MESSAGE.Loading,
			report: {
				active: true,
			},
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			// Nothing to validate at this time.

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				Active: model.report.active,
			};

			reportHelper.getReport($scope, '/api/fundreports/vendorlistingreport', report, 'VendorListingReport.pdf');
		}

		function exportExcel(model) {
			if (!validateReportParams(model)) {
				dialogHelper.openMessageBox('Vendor Listing Report Error!', null, model.validationErrors, 'Warning');
				return false;
			}

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				Active: model.report.active,
			};

			reportHelper.getExcel($scope, '/api/fundreports/vendorlistingexcel', report, 'VendorListing.xlsx');
		}

		return angular.extend(model, {
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
